<template>
    <div class="box">
        <div class="content-container">
            <div class="left-content-box" v-infinite-scroll="load">
                <no-data v-if="tableData.length == 0"></no-data>
                <div v-for="(item, index) in tableData" class="left-item"
                    :class="{ 'active-item': item.id == currentId }" @click="showSoftware(item)" :key="index">
                    <div class="task-top">
                        <el-tooltip effect="dark" :disabled="item.taskName.length>11?false:true" :content="item.taskName" placement="top-start">
                            <p class="task-name overflow">{{ item.taskName }}</p>
                        </el-tooltip>
                        <div class="label-status"
                            :style="`background-color:${filterTaskStatus(item.taskStatus).color};`">{{
                                filterTaskStatus(item.taskStatus).label}}</div>
                    </div>
                    <div class="item">
                        <p>开始时间：</p>
                        <p>{{ item.beginTime }}</p>
                    </div>
                    <div class="item">
                        <p>结束时间：</p>
                        <p>{{ item.endTime }}</p>
                    </div>
                </div>
            </div>
            <div class="right-content-box">
                <Table style="width: 100%; height: 100%;" :totalSize="softwareList.length" :pagination="false" :operationWidth="350" :currentPage="softwarePages.current"
                :pageSize="softwarePages.size" navHeight=40 ref="table" :tableData="softwareList" :tableKey="tableKey">
                <template slot="operation" slot-scope="data">
                    <div class="btn-button" v-if="isTimeArea(data.data.row.beginTime,data.data.row.endTime)" :class="{ 'disable-button': data.data.row.examineStatus == '2' }"
                        @click="startTask(data.data.row)">开始任务</div>
                    <div class="btn-button" v-else @click="viewDetail(data.data.row)">查看详情</div>    
                </template>
            </Table>
            </div>
        </div>
        <start-task ref="start_task"></start-task>
        <pratical-detail ref="pratical_detail"></pratical-detail>
    </div>
</template>

<script>
import { StuPageQueryTask, GetTaskDetail } from '@/api/trainTask';
import { openVirtual } from '@/utils/utils';
import detectProtocol from "custom-protocol-detection";
import { filterTaskStatus } from '@/utils/utils';
import NoData from '../../common/NoData.vue';
import StartTask from './StartTask.vue';
import { isTimeArea } from '@/utils/utils';
import PraticalDetail from './PraticalDetail.vue';
export default {
    components: { NoData, StartTask, PraticalDetail },
    props: ['name','examineStatus'],
    data() {
        return {
            pages: {
                current: 1,
                size: 99,
                total: 0
            },
            softwarePages:{
                current:1,
                size:10
            },
            tableData: [],
            softwareList:[],
            currentId:'',
            tableKey: [
                {
                    name: '软件名称',
                    value: 'softwareName'
                },
                {
                    name: '软件类型',
                    value: 'resType'
                },
                {
                    name: '',
                    value: 'operation',
                    slot: 'operation'
                },
            ],
        }
    },
    methods: {
        filterTaskStatus,
        isTimeArea(beginTime,endTime){
            return isTimeArea(beginTime,endTime);
        },
        load(){
            let total = this.pages.current * this.pages.size;
            if (total >= this.pages.total) return;
            this.pages.current++;
            this.stuPageQueryTask();
        },
        /**显示软件列表 */
        showSoftware(item){
            this.currentId=item.id;
            this.getTaskDetail(item);
        },
        stuPageQueryTask() {
            let params = {
                "current": this.pages.current,
                "size": this.pages.size,
                "taskName": this.name,
                "taskStatus": ""
            };
            StuPageQueryTask(params).then(res => {
                if (res.code == 200) {
                    if (this.pages.current == 1) {
                        this.tableData = res.data.records;
                    } else {
                        this.tableData = [...this.tableData, ...res.data.records];
                    }
                    this.pages.total = res.data.total;
                    if(this.tableData.length>0&&!this.currentId){
                        this.currentId=this.tableData[0].id;
                        this.getTaskDetail(this.tableData[0]);
                    }
                }
            })
        },
        /**获取任务详情 */
        getTaskDetail(data){
            GetTaskDetail({id:this.currentId}).then(res => {
                if (res.code == 200) {
                    res.data.refSoftWareInfoList.forEach(item=>{
                        item.beginTime=data.beginTime;
                        item.endTime=data.endTime;
                    })
                    this.softwareList=res.data.refSoftWareInfoList;
                }
            })
        },
        /**开始任务 */
        startTask(item) {
            if (!isTimeArea(item.beginTime, item.endTime)) return;
            if (item.resType == '单机') {
                    if (!item.regedit) {
                        this.$msg({
                            showClose: true,
                            message: "暂无资源",
                            type: "warning",
                        });
                        return;
                    }
                    detectProtocol(item.regedit + '://', () => {
                        console.log("未找到协议.");
                        this.$confirm("未检测到软件，立即下载。", "提示", {
                            confirmButtonText: "确定",
                            cancelButtonText: "取消",
                            type: "warning"
                        })
                            .then(() => {
                                if (item.fileId) {
                                    getFileInfo(item.fileId).then(res => {
                                        if (res.code == 200) {
                                            var src = this.$severUrl(res.data.fileUrl);
                                            var link = document.createElement('a');
                                            link.href = src;
                                            document.body.appendChild(link);
                                            link.click();
                                            document.body.removeChild(link);
                                        }
                                    })
                                } else {
                                    this.$msg({
                                        showClose: true,
                                        message: "暂无资源",
                                        type: "warning",
                                    });
                                }
                            })
                            .catch(() => {
                                this.$message({
                                    type: "info",
                                    message: "已取消下载"
                                });
                            });
                    },
                        () => {
                            console.log("找到自定义协议并成功打开文件.");
                        },
                        1000
                    );
                }
                else {
                    var url = openVirtual(item.url) + '?optSource=sp_training' + '&businessId=' + this.currentId + '-' + item.id;
                    window.open(url, '_blank');
                }
        },
        /**查看实训得分详情 */
        viewDetail(item) {
            let dialog = this.$refs.pratical_detail;
            if (dialog) {
                dialog.taskId = this.currentId;
                dialog.title = item.taskName;
                dialog.pages.current = 1;
                dialog.pageQueryUserTrainingRecord();
            }
        },
        handleSizeChange(e) {
            this.pages.current = 1;
            this.pages.size = e;
            this.stuPageQueryTask();
        },
        handleCurrentChange(e) {
            this.pages.current = e;
            this.stuPageQueryTask();
        },
        search() {
            this.pages.current = 1;
            this.stuPageQueryTask();
        }
    },
    watch: {
        examineStatus() {
            this.search();
        },
    },
    mounted() {
        this.search();
    }
}
</script>

<style lang="less" scoped>
.box {
    height: 100%;
}

.content-container {
    height: calc(100% - 2rem);
    display: flex;
}

.btn-button {
    width: 72px;
    height: 26px;
    background: var(--blue);
    border-radius: 0.6rem;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ffffff;
    cursor: pointer;
}

.table-item {
    border-bottom: 1px solid #e0e8f2;
    padding: 2.4rem 3.7rem 2.2rem 6.5rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.task-name {
    font-weight: 700;
    font-size: 16px;
}

.label-status {
    padding: 0.2rem 0.5rem;
    border-radius: 0.4rem 0px 0.4rem 0px;
    color: #ffffff;
}

.top-content {
    display: flex;
}

.bottom-content {
    margin-top: 12px;
    display: flex;
    font-size: 14px;
    color: #8590B3;

    &> :nth-child(n) {
        margin-left: 4.5rem;
    }

    &> :nth-child(1) {
        margin-left: 0;
    }
}

.item {
    display: flex;
    margin-top: 1rem;
}

.page-box {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 2rem;
}

.detail-img {
    width: 2.1rem;
    margin-left: 1rem;
    cursor: pointer;
}
.left-content-box {
    width: 30rem;
    height: 100%;
    overflow: auto;
    background-color: #ffffff;
    .left-item {
        padding: 2rem;
        border-bottom: 1px solid #e0e8f2;
        cursor: pointer;

        .task-name {
            font-weight: 700;
            font-size: 16px;
        }
    }
}

.active-item {
    background-color: var(--blue) !important;
    color: #ffffff !important;
}

.right-content-box {
    width: calc(100% - 35rem);
    height: 100%;
    margin-left: 5rem;
    display: flex;
    align-items: flex-start;
    flex-wrap: wrap;
    overflow: auto;
}
.task-top{
    display: flex;
    justify-content: space-between;
    align-items: center;
    &> :nth-child(1){
        flex: 1;
    }
    &> :nth-child(2){
        margin-left: 1rem;
    }
}
/deep/.table{
    height: 100%;
}
@media screen and (max-width:750px){
    .content-container{
        flex-direction: column;
    }
    .left-content-box{
        height: auto;
        width: 100%;
        display: flex;
    }
    .right-content-box{
        margin-left: 0 !important;
        margin-top: 2rem;
        width: 100%;
        flex: 1;
    }
}
</style>